import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss'],
})
export class PublicComponent {}
